import React from 'react';
import BrutalistNavbar from '../components/layout/BrutalistNavbar';
import BrutalistFooter from '../components/layout/BrutalistFooter';
import BrutalistCatalog from '../components/catalog/BrutalistCatalog';
import { Toaster } from '../components/ui/toaster';
import ScrollToTop from '../components/ui/ScrollToTop';

const CatalogPage = () => {
  return (
    <div className="min-h-screen bg-background text-foreground font-sans selection:bg-accent selection:text-white">
      <BrutalistNavbar />
      <main>
        <BrutalistCatalog />
      </main>
      <BrutalistFooter />
      <Toaster />
      <ScrollToTop />
    </div>
  );
};

export default CatalogPage;